import {
  STRIPS_CLASS,
  STRIPS_SCALE,
} from '@components/ArtBoard/Canvas/constants'
import { getCanvasState } from '@components/ArtBoard/Canvas/helpers/canvas'
import type { ID } from '@octopus-do/octopus-project-core'

import type { CanvasPayload } from '../../types'

// todo: remove usage out of saga
export const buildCanvasEvent = (
  movable: HTMLElement | null,
  payload: Partial<CanvasPayload>,
  activeTab: ID
) => {
  if (!movable) {
    return null
  }

  const canvas = getCanvasState(movable)

  const tabId = payload.tabId || activeTab

  const data = {
    scale: payload.scale || canvas.scale,
    translate: payload.translate || canvas.translate,
    print: payload.print,
  }

  sessionStorage.setItem(tabId, JSON.stringify(data))

  const scale = payload.scale || canvas.scale
  const translate = payload.translate || canvas.translate
  const tree = movable.querySelector('#tree') as HTMLElement

  const tx = parseFloat(translate[0].toFixed())
  const ty = parseFloat(translate[1].toFixed())

  if (payload.print) {
    tree.style.transform = 'scale(1)'
    tree.classList.remove(STRIPS_CLASS)
    movable.style.transform = ''

    return null
  }

  if (payload.scale) {
    tree.style.transform = `scale(${scale})`
    tree.classList.toggle(STRIPS_CLASS, scale < STRIPS_SCALE)
  }

  if (payload.translate) {
    movable.style.transform = `matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ${tx}, ${ty}, 0, 1)`
  }

  return new CustomEvent('canvas', {
    detail: { scale, tx, ty },
  })
}
